
import { Component, Provide, Mixins, Prop } from "vue-property-decorator";
import { CreateElement } from "vue";

// Mixins
import RequestPromises from "@/mixins/requestPromises";

// Enums/Data
import { DataModules } from "@/store/modules/data";

// Types
import { IReportTypesProviderData } from "@/models/providers/reports";
import { IReportType } from "@/models/reports";

@Component
export default class ReportTypesProvider extends Mixins(RequestPromises) {
  // Props
  @Prop({ default: true })
  public declare handleLoading: boolean;

  @Prop({ default: true })
  public declare handleGuarding: boolean;

  @Prop({ default: true })
  public declare handleRequestError: boolean;

  // Data
  public reports: IReportType[] = [];

  public isLoading = true;
  public isReloading = false;
  public requestError = false;

  // Life-cycle Methods

  public async created() {
    this.loadData();
  }

  public async loadData() {
    try {
      this.reports = await this.getReports();
    } catch (error) {
      this.$store.dispatch("api/handleError", error);
      this.requestError = true;
    } finally {
      this.isLoading = false;
      this.isReloading = false;
    }
  }

  public reloadData() {
    this.isReloading = true;
    this.loadData();
  }

  public getReports() {
    return this.$store.dispatch(`data/${DataModules.REPORTS}/get`, {
      storeData: false,
      returnData: true,
      vm: this
    });
  }

  // Provide

  @Provide("reportsProviderData")
  public providerData(): IReportTypesProviderData {
    return {
      reports:
        this.isLoading || !this.reports.length
          ? Array(this.reports.length || 5)
          : this.reports,
      isLoading: this.isLoading
    };
  }

  // Render

  public render(h: CreateElement) {
    // Handle loading
    if (this.handleLoading && this.isLoading)
      return h("is-loading", { props: { if: true } });

    // Handle request error
    if (this.handleRequestError && this.requestError)
      return h("request-error", {
        props: { isLoading: this.isReloading && this.requestError },
        on: { click: () => this.reloadData() }
      });

    return (
      this.$scopedSlots?.default &&
      this.$scopedSlots.default({
        $reportsData: this.providerData()
      })
    );
  }
}
